/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAppLogoDirectUploadMutationVariables = Types.Exact<{
  input: Types.IAppLogoDirectUploadInput;
}>;

export type IAppLogoDirectUploadMutation = {
  __typename?: 'Mutation';
  appLogoDirectUpload?: {
    __typename?: 'AppLogoDirectUploadPayload';
    errors?: Array<string> | null;
    success: boolean;
    headers?: any | null;
    signedId?: string | null;
    url?: string | null;
  } | null;
};

export const AppLogoDirectUploadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'appLogoDirectUpload' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppLogoDirectUploadInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appLogoDirectUpload' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'headers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAppLogoDirectUploadMutation, IAppLogoDirectUploadMutationVariables>;
